import {Button, DialogContentText, Popover, Typography} from '@mui/material';
import {DialogActions, DialogContent} from '@mui/material';
import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';

type DeletePopoverProps = {
    onConfirmation: (event: React.MouseEvent<HTMLButtonElement>) => void;
    title?: string;
    description?: string | ReactNode;
    confirmText?: string;
    anchorEl: any;
    onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const DeletePopover = ({
    onConfirmation,
    title,
    description,
    confirmText,
    onClose,
    anchorEl,
}: DeletePopoverProps) => {
    const open = Boolean(anchorEl);

    const id = open ? 'popover' : undefined;

    const {t} = useTranslation('common');

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    sx: {
                        backgroundColor: 'var(--mui-palette-paper_elevation-16) !important',
                        backgroundImage: 'none !important',
                        maxWidth: 300,
                        wordWrap: 'break-word',
                    },
                },
            }}
        >
            <Typography
                variant='subtitle2'
                padding={2}
                sx={{
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                }}
            >
                {title || `${t('sureDelete')} ${t('record').toLowerCase()}?`}
            </Typography>
            {description && (
                <DialogContent sx={{padding: '6px 16px'}}>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                <Button
                    size='small'
                    onClick={onClose}
                >
                    {t('cancel')}
                </Button>
                <Button
                    onClick={onConfirmation}
                    variant='contained'
                    color='primary'
                    size='small'
                >
                    {confirmText || t('delete')}
                </Button>
            </DialogActions>
        </Popover>
    );
};
